<section class="portal-manage">
  <div class="portal-manage__background"></div>

  <div class="portal-manage__shell">
    <header class="portal-manage__topbar">
      <a class="portal-manage__brand" [href]="'/'" aria-label="Virtualcenter">
        <img
          src="assets/images/branding/virtualcenter-logo-horizontal-negro.png"
          alt="Virtualcenter"
          class="portal-manage__brand-logo"
        />
        <div class="portal-manage__brand-copy">
          <span>Gestión de reserva</span>
        </div>
      </a>

      <div class="portal-manage__topbar-meta" *ngIf="booking?.site">
        <span>{{ booking?.customer?.name }}</span>
        <span class="portal-manage__topbar-dot">•</span>
        <span>{{ booking?.site?.name }}</span>
      </div>
    </header>

    <main class="portal-manage__content">
      <header class="portal-manage__hero" *ngIf="booking?.site">
        <div class="portal-manage__hero-badge">{{ booking?.customer?.name }}</div>
        <h1>{{ booking?.site?.name }}</h1>
        <p>
          Gestiona tu reserva con la referencia <strong>{{ booking?.booking_reference }}</strong>.
          Desde aquí puedes revisar cada cita, cancelarla o reprogramarla.
        </p>
      </header>

      <section class="portal-manage__panel" *ngIf="loading">
        <p>Cargando reserva...</p>
      </section>

      <section class="portal-manage__panel portal-manage__panel--state" *ngIf="!loading && errorMessage">
        <p>{{ errorMessage }}</p>
      </section>

      <section class="portal-manage__panel" *ngIf="!loading && booking">
        <div class="portal-manage__panel-head">
          <h2>Reserva</h2>
          <p>{{ booking?.patient?.name }} {{ booking?.patient?.surname }} · {{ booking?.patient?.email }}</p>
        </div>

        <article class="portal-manage__appointment" *ngFor="let appointment of booking?.appointments || []">
          <div class="portal-manage__appointment-head">
            <div>
              <strong>{{ appointment?.treatment?.name || 'Cita' }}</strong>
              <div>{{ formatTimeRange(appointment) }}</div>
            </div>
            <span class="portal-manage__status">{{ appointment?.status?.name || appointment?.approval_state }}</span>
          </div>

          <p *ngIf="appointment?.professional">
            Profesional: {{ appointment?.professional?.name }} {{ appointment?.professional?.surname }}
          </p>
          <p *ngIf="appointment?.counter_proposal">
            Propuesta clínica: {{ formatTimeRange(appointment?.counter_proposal) }}
          </p>

          <div class="portal-manage__actions">
            <button
              type="button"
              class="portal-manage__button portal-manage__button--ghost"
              *ngIf="appointment?.can_reschedule"
              (click)="startReschedule(appointment)"
            >
              Reprogramar
            </button>
            <button
              type="button"
              class="portal-manage__button portal-manage__button--danger"
              *ngIf="appointment?.can_cancel"
              (click)="cancelAppointment(appointment)"
            >
              Cancelar
            </button>
          </div>
        </article>
      </section>

      <section class="portal-manage__panel" *ngIf="selectedAppointment">
        <div class="portal-manage__panel-head">
          <h2>Reprogramar cita</h2>
          <p>{{ selectedAppointment?.treatment?.name }} · {{ formatTimeRange(selectedAppointment) }}</p>
        </div>

        <div class="portal-manage__calendar-layout">
          <section class="portal-manage__calendar-panel">
            <div class="portal-manage__calendar-header">
              <button
                type="button"
                class="portal-manage__button portal-manage__button--ghost"
                [disabled]="!canGoToPreviousMonth"
                (click)="previousMonth()"
              >
                ‹
              </button>
              <strong>{{ monthLabel }}</strong>
              <button
                type="button"
                class="portal-manage__button portal-manage__button--ghost"
                [disabled]="!canGoToNextMonth"
                (click)="nextMonth()"
              >
                ›
              </button>
            </div>

            <div class="portal-manage__calendar-weekdays">
              <span>Lun</span>
              <span>Mar</span>
              <span>Mié</span>
              <span>Jue</span>
              <span>Vie</span>
              <span>Sáb</span>
              <span>Dom</span>
            </div>

            <div class="portal-manage__calendar-grid">
              <button
                type="button"
                class="portal-manage__calendar-day"
                *ngFor="let cell of calendarCells"
                [disabled]="!cell.available"
                [class.portal-manage__calendar-day--ghost]="!cell.currentMonth"
                [class.portal-manage__calendar-day--available]="cell.available"
                [class.portal-manage__calendar-day--selected]="cell.selected"
                (click)="selectCalendarDay(cell.key)"
              >
                {{ cell.label }}
              </button>
            </div>
          </section>

          <section class="portal-manage__slots-panel">
            <div class="portal-manage__panel-head">
              <h3>Horas disponibles</h3>
              <p *ngIf="selectedDayKey; else noSelectedDay">Selecciona una nueva franja horaria.</p>
              <ng-template #noSelectedDay>
                <p>Selecciona primero un día con disponibilidad.</p>
              </ng-template>
            </div>

            <div class="portal-manage__slots">
              <button
                type="button"
                *ngFor="let slot of availableSlots"
                [class.portal-manage__slot--active]="selectedSlot?.start_utc === slot.start_utc && selectedSlot?.end_utc === slot.end_utc"
                (click)="selectSlot(slot)"
              >
                {{ formatTimeRange(slot) }}
              </button>
              <p *ngIf="selectedDayKey && !availableSlots.length">No hay horas disponibles para este día.</p>
            </div>

            <div class="portal-manage__professionals" *ngIf="usesProfessionalRouting && selectedSlot">
              <div class="portal-manage__panel-head portal-manage__panel-head--spaced">
                <h3>Profesional</h3>
                <p>Si no eliges ninguno, se mantendrá la asignación automática.</p>
              </div>

              <div class="portal-manage__professional-list">
                <button
                  type="button"
                  class="portal-manage__professional-card"
                  [class.portal-manage__professional-card--selected]="selectedProfessionalUsersId === null"
                  (click)="selectProfessional(null)"
                >
                  Asignación automática
                </button>
                <button
                  type="button"
                  class="portal-manage__professional-card"
                  *ngFor="let professional of availableProfessionals"
                  [class.portal-manage__professional-card--selected]="selectedProfessionalUsersId === professional.users_id"
                  (click)="selectProfessional(professional.users_id)"
                >
                  {{ getProfessionalName(professional) }}
                </button>
              </div>
            </div>
          </section>
        </div>

        <footer class="portal-manage__actions">
          <button type="button" class="portal-manage__button portal-manage__button--ghost" (click)="closeReschedule()">
            Cerrar
          </button>
          <button type="button" class="portal-manage__button" [disabled]="actionLoading" (click)="confirmReschedule()">
            Confirmar nueva fecha
          </button>
        </footer>
      </section>
    </main>

    <footer class="portal-manage__footer">
      <div class="portal-manage__footer-brand">
        <img
          src="assets/images/branding/virtualcenter-isotipo-negro.png"
          alt="Virtualcenter"
          class="portal-manage__footer-logo"
        />
        <span>Powered by Virtualcenter</span>
      </div>
      <div class="portal-manage__footer-copy">
        <span>Experiencia de reserva y seguimiento para pacientes</span>
        <span class="portal-manage__topbar-dot">•</span>
        <a href="mailto:soporte&#64;virtualcenter.com" class="portal-manage__inline-link">
          soporte&#64;virtualcenter.com
        </a>
      </div>
    </footer>
  </div>
</section>
